module.exports = __webpack_public_path__ + "static/img/map.9eaf2b34.png";